/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.25/esri/copyright.txt for details.
*/
var E;!function(E){E[E.NONE=0]="NONE",E[E.NONE_HIT_MAXLOD=1]="NONE_HIT_MAXLOD",E[E.SPLIT=2]="SPLIT",E[E.VSPLITMERGE=4]="VSPLITMERGE",E[E.MERGE=8]="MERGE",E[E.RENDERDATA=16]="RENDERDATA",E[E.GEOMETRY=32]="GEOMETRY",E[E.TEXTURE_NOFADING=64]="TEXTURE_NOFADING",E[E.TEXTURE_FADING=128]="TEXTURE_FADING"}(E||(E={}));export{E as TileUpdate};
